import React from "react";
import { FaCheck } from "react-icons/fa";
import { Col, Row } from "react-bootstrap";
import styles from "./About.module.scss";
import { GoDotFill } from "react-icons/go";

const About = ({ physicianInfo }) => {
  return (
    <>
      <div className={styles.aboutMainDiv}>
        <div className={styles.aboutDiv}>
          <h4 className="text-primary">About Me</h4>
          <p>{physicianInfo?.aboutDoctor}</p>
        </div>
      </div>
      <div className={styles.treatmentDiv}>
        <h4 className="text-primary mb-3">Treatments</h4>
        <Row className={styles.treatmentRow}>
          <Row className={styles.treatmentRow}>
            {physicianInfo &&
              physicianInfo.treatments &&
              physicianInfo.treatments.length > 0 &&
              physicianInfo.treatments.map((treatment, index) =>
                index % 3 === 0 ? (
                  <Col md={4} className={styles.treatmentCol} key={index}>
                    <ul>
                      {physicianInfo.treatments
                        .slice(index, index + 3)
                        .map((treatmentItem, i) => (
                          <li key={i}>
                            <FaCheck />
                            <span>{treatmentItem?.treatmentName}</span>
                          </li>
                        ))}
                    </ul>
                  </Col>
                ) : null
              )}
          </Row>
        </Row>
      </div>
      <div className={styles.languageDiv}>
        <h4 className="text-primary">Language</h4>
        <Row>
          {physicianInfo &&
            physicianInfo.language &&
            physicianInfo.language.length > 0 &&
            physicianInfo.language.map((language, index) =>
              index % 3 === 0 ? (
                <Col md={4} key={index}>
                  {physicianInfo.language
                    .slice(index, index + 3)
                    .map((lang, i) => (
                      <p key={i}>
                        <span>
                          <GoDotFill />
                        </span>
                        {lang?.name}
                      </p>
                    ))}
                </Col>
              ) : null
            )}
        </Row>
      </div>
    </>
  );
};

export default About;
